export const environment = {
  production: true,
  errbitKey: '305e1fb5e622e7ee161a5696444da8d0',
  errbitHost: 'https://errbit.mcc.software',
  initialApiUrl: undefined,
  intercomAppId: 'kwkztacu',
  intercomSecretKey: 'N3cvTnxmjGFl7EKxKgdaMHvmL7LYh0fq9bUvRCni',
};

export const TOKEN_KEY = 'mccapikey';
